var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticStyle:{"background-color":"#f9f9fb"},attrs:{"fluid":""}},[_c('v-row',[_c('v-col',[_c('h2',{staticClass:"cnx"},[_vm._v("Set up")])])],1),_c('br'),_c('br'),_c('br'),_c('contentDashboards',{attrs:{"parent-exists":_vm.dataExists}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }